module.exports = {versao:  1345 ,
url:"https://sec-api.aplicativogo.com.br"};
